import styled from 'styled-components';

interface IDefaultContainerProps {}

export const DefaultContainer = styled.div<IDefaultContainerProps>`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  max-height: 100vh;
  font-family: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
`;

export const MainContainer = styled.div<IDefaultContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height:100%
  border: 2px solid ${(prop) => prop.theme.border.medium};
  background: ${(prop)=>prop.theme.background.surface};
  border-radius: 4px;
  margin: 0.75rem 0rem 4.6rem 0.5rem;

  #alertMessage {
    width: 100%;
    margin-bottom: 0.5rem;
    color:red;
    text-align:left;
    background: ${(prop)=>prop.theme.background.surface};
    borderradius: 4px;
    border: ${(prop) => prop.theme.border.medium};
    fontfamily: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
    fontsize: 0.75rem;
  }
  #alertMessage button{
    height:30px;
    width:25px;
    
  }
  #alertMessage svg path{
    fill:red;
  }
`;

interface IDefaultTitleContainerProps {}

export const DefaultTitleContainer = styled.div<IDefaultTitleContainerProps>`
  font-size: 1.25rem;
  text-align: left;
  line-height: 28px;
  letter-spacing: 0em;
  color: #d9d9d9;
  padding: 1rem 1rem 1rem 1rem;
  border: 2px solid ${(prop) => prop.theme.border.medium};
`;
